import React from 'react';
import {
  Button,
  IStackProps,
  Stack,
  IButtonProps,
} from '@grubhubprod/gh-cookbook-react/dist';

export type DataTableButtonProps = Partial<IButtonProps> & IStackProps;

export const DataTableButton: React.FC<DataTableButtonProps> = ({
  children,
  x = 'none',
  y = 'none',
  ...rest
}) => (
  <Stack x={x} y={y}>
    <Button buttonSize="small" {...rest}>
      {children}
    </Button>
  </Stack>
);
